import { useEffect, useState } from 'react'
import { ForYourVehicleProp } from 'models/sectionForYourVehicle'
import { getForYourVehicle } from 'services/forYourVehicle'

export const useForYourVehicleController = () => {
  const [dataForYourVehicle, setForYourVehicle] = useState<ForYourVehicleProp>([])
  const [loadingForYourVehicle, setLoading] = useState(true)

  useEffect(() => {
    getForYourVehicle().then(data => {
      setForYourVehicle(data)
      setLoading(false)
    })
  }, [])

  return {
    dataForYourVehicle,
    loadingForYourVehicle,
  }
}
